import Flickity from 'flickity';
import FAQs from '../modules/FAQ';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class ProductController {

  constructor(options) {
    this.options = options;
    console.log('PRODUCT CONTROLLER');

    $('nav.siteNav__main>div>a.submenu__products').addClass('is-activepage');

    this.faqs = new FAQs();

    if ( $('.product__item').length > 0 ) {

      this.flkty = new Flickity( 'div.product__items', {
        arrowShape: { x0: 0, x1: 40, y1: 50, x2: 45, y2: 50, x3: 5 },
        cellAlign: 'left',
        groupCells: true,
      });

    }

    $('.product__info .texts .panel, .product__details .panel').on('click', function(){

      var c = $(this).data('id');
      $(this).toggleClass('active');
      $('#' + c).toggleClass('active');

    });

    $('.faqs .panel').on('click', function(){

      var c = $(this).data('id');
      $(this).toggleClass('active');
      $(this).next().toggleClass('active');

    });

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });
  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/ProductController.js